<div class="dialog">
  <span class="dialog-close" (click)="close()">
    <i class="fa fa-close"></i>
  </span>
  <h2 class="dialog-header">{{ modalTitle | translate }}</h2>
  <div class="dialog-content">
    <div class="action-crop">
      <!-- Browse file -->
      <label class="custom-file-upload">
        <i class="fa fa-folder-open"></i> {{ 'BROWSE' | translate }}
        <input type="file" (change)="fileChangeEvent($event)" />
      </label>

      <div class="pull-right btn-toolbar" *ngIf="this.croppedImage">
        <!-- Zoom out -->
        <button type="button" class="btn" (click)="zoomOut()" [disabled]="sendingForm">
          <i class="fa fa-search-minus"></i>
        </button>

        <!-- Zoom in -->
        <button type="button" class="btn" (click)="zoomIn()" [disabled]="sendingForm">
          <i class="fa fa-search-plus"></i>
        </button>

        <!-- Reset -->
        <button type="button" class="btn" (click)="resetImage()" [disabled]="sendingForm">
          {{ 'RESET' | translate }}
        </button>
      </div>
    </div>

    <!-- <div class="row"> -->
    <!-- <div class="col-md-7"> -->
    <image-cropper
      [imageChangedEvent]="imageChangedEvent"
      [maintainAspectRatio]="true"
      [transform]="transform"
      format="jpeg"
      [resizeToWidth]="width"
      [cropperMinWidth]="width"
      [cropperMaxWidth]="width"
      (imageCropped)="imageCropped($event)"
      (imageLoaded)="imageLoaded()"
    ></image-cropper>
    <!-- (cropperReady)="cropperReady()" -->
    <!-- (loadImageFailed)="loadImageFailed()" -->
    <!-- [resizeToHeight]="height" -->
    <!-- [aspectRatio]="4 / 3" -->
    <!-- </div> -->
    <!-- <div class="col-md-5"> -->
    <!-- <img [src]="croppedImage" /> -->
    <!-- </div> -->
    <!-- </div> -->
  </div>

  <!-- <img [src]="croppedImage" /> -->

  <div class="dialog-actions">
    <app-spinner-form-actions *ngIf="sendingForm"></app-spinner-form-actions>

    <!-- Cancel -->
    <button type="button" class="btn btn-lg" (click)="close()" [disabled]="sendingForm">
      <i class="fa fa-undo"></i> {{ 'CANCEL' | translate }}
    </button>

    <!-- Crop image -->
    <button
      type="button"
      class="btn btn-lg btn-primary"
      (click)="startCropImage()"
      [disabled]="!this.croppedImage || sendingForm"
    >
      {{ 'ACCEPT' | translate }}
    </button>
  </div>
</div>
